var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",class:`icon-${_vm.icon}`},[_c('use',{attrs:{"xlink:href":`${_vm.svgSpriteSrc}#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }